import { getEnvironmentLabel, isLocalhost } from "@maersk-global/shared-js";
import { AUTHORITY_URL } from "@/utils/application";
import { localStorage } from "reactive-localstorage";
import { environmentData } from "@/helper/environment";

export const getAuthorityUrl = (): string => {
  const environmentLabel: string = getEnvironmentLabel();

  return AUTHORITY_URL[environmentLabel] || "";
};
export const getJwtToken = () => {
  let id_token: any;
  for (const [key, value] of Object.entries(localStorage)) {
    if (key.includes(".access_token")) {
      id_token = value;
    }
  }
  return id_token;
};

export const initializeIamViaIgn = () => {
  if ("IGN_IAM_Initialiser" in window) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.IGN_IAM_Initialiser({
      appURL:
        isLocalhost(window.location.hostname) || window.location.origin.includes(".track-and-trace")
          ? window.location.origin
          : window.location.origin + "/track-and-trace",
      clientId: "apmt001",
      authority: getAuthorityUrl(),
      redirectUri: environmentData.redirectUrl || window.location.origin + "/track-and-trace"
    });
  }
};

export const ignLoginRedirect = () => {
  if ("IGN_IAM_Service_Provider" in window) {
    const interval = setInterval(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.IGN_IAM_Service_Provider.loginRedirect({
        response_type: "code",
        scopes: ["openid", "profile", "email"],
        redirectUri: environmentData.redirectUrl || window.location.origin + "/track-and-trace"
      });
      clearInterval(interval);
    }, 100);
  }
};
